import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('to-top-fill-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.714 3c-11.598 0-21 9.401-21 21 0 11.598 9.402 21 21 21 11.597 0 21-9.402 21-21 0-11.599-9.4-21-21-21z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: props.strokeWidth
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.773 13.5h19"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: props.strokeLinejoin
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.773 27l9.5-9.582 9.5 9.582M24.17 38V17"
  })))));
});